

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ICrossroadItemModel from "./model/ICrossroadItem";

@Component
export default class CrossroadItem extends Vue {
    @Prop({ type: Object, required: true }) private item!: ICrossroadItemModel;
}
